import { z } from "zod";
import { telemetryDataProviderSchema } from "../_shared";

export const createAnalyticVehiclesPayloadSchema = z.object({
  vehicleUuid: z.uuid(),
  vin: z.string(),
  brand: z.string(),
  dataProvider: telemetryDataProviderSchema.nullable(),
  companyUuid: z.uuid(),
  department: z.uuid().nullable(),
  deviceId: z.string().nullable(),
});

export type CreateAnalyticVehiclesPayload = z.infer<
  typeof createAnalyticVehiclesPayloadSchema
>;
